import { useState } from 'react';

import { cn } from '@/lib/utils';

const initialsOf = (name?: string) =>
  (name || '?')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase())
    .join('') || '?';

/** A logo in a small rounded square — or the name's initials when there is none, or it fails to load. */
export function LogoMark({ src, name, alt = '', className }: { src?: string | null; name?: string; alt?: string; className?: string }) {
  const [broken, setBroken] = useState(false);
  return (
    <span className={cn('flex shrink-0 items-center justify-center overflow-hidden rounded-lg border bg-muted/40', className)}>
      {src && !broken ? (
        <img src={src} alt={alt} className="size-full object-contain" onError={() => setBroken(true)} />
      ) : (
        <span className="text-xs font-medium text-muted-foreground" aria-hidden>
          {initialsOf(name)}
        </span>
      )}
    </span>
  );
}
